export default "__VITE_ASSET__2453726e__"